import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import Collapse from 'react-bootstrap/Collapse';

import { deleteAssembly } from 'shared/product_tabs/tab_assembly/slice/assemblySlice';

const assemblyProductNames = {
  'assembly-us': 'USA PCB Assembly',
  'assembly-mx': 'Mexico PCB Assembly',
};

const Assembly = (props) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const {
    quantity,
    unitPrice,
    leadTime,
    subTotal,
    selected,
    supplier,
  } = props;

  if (!selected) return null;

  const onDelete = () => {
    dispatch(deleteAssembly());
    setOpen(false);
  };

  const onToggle = () => setOpen(!open);

  return (
    <div className="cart-section assembly">
      <div className="title">
        {assemblyProductNames[supplier]}
        <button type="button" onClick={onDelete} className="btn btn-link float-right btn-delete">
          <FontAwesomeIcon icon={faTrashCan} />
        </button>
      </div>
      <div className="position-relative">
        <div className="price">{subTotal !== undefined ? `$${subTotal}` : null}</div>
        <div className="toggle-details">
          <button type="button" className="btn btn-link p-0" onClick={onToggle}>
            {open ? Spree.translations.view_less : Spree.translations.view_more}
          </button>
        </div>
        <Collapse in={open}>
          <div>
            <div className="details">
              <div className="detail">
                <strong>
                  {Spree.translations.lead_time}
                  :
                </strong>
                &nbsp;
                {leadTime}
              </div>
              <div className="detail">
                <strong>
                  {Spree.translations.quantity}
                  :
                </strong>
                &nbsp;
                {quantity}
              </div>
              <div className="detail">
                <strong>
                  {Spree.translations.unit_price}
                  :
                </strong>
                &nbsp;
                {unitPrice !== undefined ? `$${unitPrice.toFixed(2)}` : null}
              </div>
            </div>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default Assembly;
